import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import CloseIcon from "@mui/icons-material/Close";
import RedoIcon from "@mui/icons-material/Redo";
import SaveIcon from "@mui/icons-material/Save";
import UndoIcon from "@mui/icons-material/Undo";

import ButtonGroup from "lib/ui/button/ButtonGroup";

import { asTitle } from "utils/Utils";
import FeedbackIconButton from "utils/FeedbackIconButton";

export type EditActionbarProps = {
	undoEnabled: boolean;
	redoEnabled: boolean;
	saveEnabled: boolean;

	onUndo: () => void;
	onRedo: () => void;
	onSave: () => Promise<void>;
	onClose: () => void;
};

export default function EditActionbar(
	props: Readonly<EditActionbarProps>
): JSX.Element {
	const { t } = useTranslation();

	return (
		<ButtonGroup>
			<Tooltip title={asTitle(t("undo"))}>
				<span>
					<IconButton
						aria-label="undo"
						disabled={!props.undoEnabled}
						onClick={props.onUndo}
						size="large">
						<UndoIcon />
					</IconButton>
				</span>
			</Tooltip>
			<Tooltip title={asTitle(t("redo"))}>
				<span>
					<IconButton
						aria-label="redo"
						disabled={!props.redoEnabled}
						onClick={props.onRedo}
						size="large">
						<RedoIcon />
					</IconButton>
				</span>
			</Tooltip>
			<Divider orientation="vertical" flexItem />
			<Tooltip title={asTitle(t("save"))}>
				<span>
					<FeedbackIconButton
						aria-label="save"
						disabled={!props.saveEnabled}
						onClick={props.onSave}
						size="large">
						<SaveIcon />
					</FeedbackIconButton>
				</span>
			</Tooltip>
			<Tooltip title={asTitle(t("close"))}>
				<IconButton
					aria-label="close"
					onClick={props.onClose}
					size="large">
					<CloseIcon />
				</IconButton>
			</Tooltip>
		</ButtonGroup>
	);
}
